import React, { useEffect } from 'react';

import { QueryInterop as Query } from '@confluence/apollo-relay-interop/entry-points/QueryInterop.ts';

import ContentViewedEventQuery from './__generated__/ContentViewedEventQuery.graphql.ts';

type ContentViewedEventProps = {
	contentId: string;
};

let lastContentId: string;

export const ContentViewedEvent = ({ contentId }: ContentViewedEventProps) => {
	useEffect(() => {
		lastContentId = contentId;
	}, [contentId]);

	return (
		<Query
			query={ContentViewedEventQuery}
			variables={{ contentId }}
			fetchPolicy="network-only"
			skip={lastContentId === contentId}
		>
			{() => null}
		</Query>
	);
};
